var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup131(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6487 11.4233V5.46624C14.6484 5.20508 14.5782 4.94858 14.4451 4.72248C14.3121 4.49637 14.1208 4.30861 13.8905 4.17803L8.58262 1.19952C8.35208 1.06881 8.09056 1 7.82436 1C7.55815 1 7.29664 1.06881 7.06609 1.19952L1.75826 4.17803C1.52795 4.30861 1.33665 4.49637 1.20356 4.72248C1.07047 4.94858 1.00027 5.20508 1 5.46624V11.4233C1.00027 11.6844 1.07047 11.9409 1.20356 12.167C1.33665 12.3931 1.52795 12.5809 1.75826 12.7115L7.06609 15.69C7.29664 15.8207 7.55815 15.8895 7.82436 15.8895C8.09056 15.8895 8.35208 15.8207 8.58262 15.69L13.8905 12.7115C14.1208 12.5809 14.3121 12.3931 14.4451 12.167C14.5782 11.9409 14.6484 11.6844 14.6487 11.4233Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10199 2.86121L7.51417 4.72239L10.9263 2.86121",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10198 14.0283V10.3083L1 8.44476",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6487 8.44476L10.9263 10.3083V14.0283",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.72235L7.51416 8.44473L14.0283 4.72235",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82437 15.8895V8.44476",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup131);
export default __webpack_public_path__ + "static/media/Group 131.982a19a726e14fd26003d60291a4e160.svg";
export { ForwardRef as ReactComponent };